import {
    createNativeStackNavigator
} from "@react-navigation/native-stack";
import Login from "../../pages/auth/login";
import ResetPassword from "../../pages/auth/resetPassword";

const Stack = createNativeStackNavigator();

const AuthStack = () => {
    return <Stack.Navigator
        initialRouteName="Login"
        screenOptions={{
            headerShown: false
        }}
    >
        <Stack.Screen
            name="Login"
            component={Login}
        />
        <Stack.Screen
            name="ResetPassword"
            component={ResetPassword}
        />
    </Stack.Navigator>;
};
export default AuthStack;
